import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-landing-modal',
  templateUrl: './landing-modal.component.html',
  styleUrls: ['./landing-modal.component.css']
})
export class LandingModalComponent implements OnInit {
  @Input() modalRef: NgbModalRef;
  @Input() centreName: string;

  constructor(
  ) { }

  ngOnInit() {
  }

  close() {
    this.modalRef.close();
  }
}
